import { WebCheckInFormFields } from "../../components/Layouts/WebCheckInForms/FormOptions";

export const CustomerDetailFormField = {
  firstName: WebCheckInFormFields.firstName,
  middleName: WebCheckInFormFields.middleName,
  lastName: WebCheckInFormFields.lastName,
  email: {
    ...WebCheckInFormFields.email,
    type: "email",
    required: true,
  },
  mobileNumber: {
    ...WebCheckInFormFields.mobileNumber,
    required: true,
  },
  country: WebCheckInFormFields.country,
  city: WebCheckInFormFields.city,
  state: WebCheckInFormFields.state,
  zip: WebCheckInFormFields.zip,
  streetName: {
    ...WebCheckInFormFields.streetName,
    variant: "standard",
  },
  n: WebCheckInFormFields.n,
  birthNation: {
    ...WebCheckInFormFields.birthNation,
    type: "select",
    variant: "standard",
  },
  birthDate: {
    ...WebCheckInFormFields.birthDate,
    variant: "standard",
    required: true,
  },
  birthPlace: WebCheckInFormFields.birthPlace,
  birthProv: WebCheckInFormFields.birthProv,
  gender: { ...WebCheckInFormFields.gender, required: true },
  ssn: WebCheckInFormFields.ssn,
  flightNumber: {
    type: "text",
    label: "Flight Number",
    key: "flightNumber",
    placeholder: "Flight Number",
    required: false,
    options: [],
  },
};

export const PrivateCustomerDetailFormField = {
  country: { ...WebCheckInFormFields.country, required: true },
  city: { ...WebCheckInFormFields.city, required: true },
  state: { ...WebCheckInFormFields.state, required: true },
  zip: { ...WebCheckInFormFields.zip, required: true },
  streetName: {
    ...WebCheckInFormFields.streetName,
    variant: "standard",
    required: true,
  },
  n: { ...WebCheckInFormFields.n, required: true },
  birthNation: {
    ...WebCheckInFormFields.birthNation,
    type: "select",
    variant: "standard",
    required: true,
  },
  birthDate: {
    ...WebCheckInFormFields.birthDate,
    variant: "standard",
    required: true,
  },
  birthPlace: { ...WebCheckInFormFields.birthPlace, required: true },
  birthProv: { ...WebCheckInFormFields.birthProv, required: true },
  gender: { ...WebCheckInFormFields.gender, required: true },
  ssn: { ...WebCheckInFormFields.ssn, required: true },
  flightNumber: {
    type: "text",
    label: "Flight Number",
    key: "flightNumber",
    placeholder: "Flight Number",
    required: false,
    options: [],
  },
};
